const INITIAL_STATE = {
    data: [],
    loading: false,
    error: false
};

export default function room(state = INITIAL_STATE, action){
    switch (action.type){
        case "ADD_ROOM":
            return { ...state, loading: true }
        case "SUCCESS_ADD_ROOM":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_ADD_ROOM":
            return { data: [], loading: false, error: true }
        case "REMOVE_ROOM":
            return { ...state, loading: true }
        case "SUCCESS_REMOVE_ROOM":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_REMOVE_ROOM":
            return { data: [], loading: false, error: true }
        case "UPDATE_ROOM":
            return { ...state, loading: true }
        case "SUCCESS_UPDATE_ROOM":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_UPDATE_ROOM":
            return { data: [], loading: false, error: true }
        case "GET_ROOMS":
            return { ...state, loading: true }
        case "SUCCESS_GET_ROOMS":
            return { data: action.payload.data, loading: false, error: false }
        case "FAILURE_GET_ROOMS":
            return { data: [], loading: false, error: true }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/room.js